module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_sugar_phosphate_backbone_dna_7-eb77ea2f77722e4d1f72b45744eac3cd.jpg";